import { render, staticRenderFns } from "./PageNotifications.vue?vue&type=template&id=919b2dee&"
import script from "./PageNotifications.vue?vue&type=script&lang=ts&"
export * from "./PageNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports